"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenApiOAuthClientCredentialsFlow = exports.OpenApiOAuthPasswordFlow = exports.OpenApiOAuthAuthorizationCodeFlow = exports.OpenApiOAuthImplicitFlow = exports.OpenApiOAuthFlow = void 0;
const utils_1 = require("@dev-stream/utils");
const utils_2 = require("@dev-stream/utils");
class OpenApiOAuthFlow extends utils_1.BaseModel {
    constructor() {
        super(...arguments);
        this.BASE_TYPE = OpenApiOAuthFlow;
    }
    GetDefaultValue() {
        return {
            scopes: {},
        };
    }
    static isOpenApiOAuthFlow(o) {
        return (o instanceof OpenApiOAuthFlow ||
            (0, utils_2.hasUnionKeysStrict)(o, ["scopes"]));
    }
}
exports.OpenApiOAuthFlow = OpenApiOAuthFlow;
class OpenApiOAuthImplicitFlow extends OpenApiOAuthFlow {
    GetDefaultValue() {
        return Object.assign(Object.assign({}, super.GetDefaultValue()), { authorizationUrl: "" });
    }
    constructor(...parts) {
        super(...parts);
        this.BASE_TYPE = OpenApiOAuthImplicitFlow;
    }
    static isOpenApiOAuthImplicitFlow(o) {
        return (o instanceof OpenApiOAuthImplicitFlow ||
            (OpenApiOAuthFlow.isOpenApiOAuthFlow(o) &&
                (0, utils_2.hasUnionKeysStrict)(o, [
                    "authorizationUrl",
                ])));
    }
}
exports.OpenApiOAuthImplicitFlow = OpenApiOAuthImplicitFlow;
class OpenApiOAuthAuthorizationCodeFlow extends OpenApiOAuthFlow {
    GetDefaultValue() {
        return Object.assign(Object.assign({}, super.GetDefaultValue()), { authorizationUrl: "", tokenUrl: "" });
    }
    constructor(...parts) {
        super(...parts);
        this.BASE_TYPE = OpenApiOAuthAuthorizationCodeFlow;
    }
    static isOpenApiOAuthImplicitFlow(o) {
        return (o instanceof OpenApiOAuthAuthorizationCodeFlow ||
            (OpenApiOAuthFlow.isOpenApiOAuthFlow(o) &&
                (0, utils_2.hasUnionKeysStrict)(o, [
                    "authorizationUrl",
                    "tokenUrl",
                ])));
    }
}
exports.OpenApiOAuthAuthorizationCodeFlow = OpenApiOAuthAuthorizationCodeFlow;
class OpenApiOAuthPasswordFlow extends OpenApiOAuthFlow {
    GetDefaultValue() {
        return Object.assign(Object.assign({}, super.GetDefaultValue()), { tokenUrl: "" });
    }
    constructor(...parts) {
        super(...parts);
        this.BASE_TYPE = OpenApiOAuthPasswordFlow;
    }
    static isOpenApiOAuthImplicitFlow(o) {
        return (o instanceof OpenApiOAuthPasswordFlow ||
            (OpenApiOAuthFlow.isOpenApiOAuthFlow(o) &&
                (0, utils_2.hasUnionKeysStrict)(o, ["tokenUrl"])));
    }
}
exports.OpenApiOAuthPasswordFlow = OpenApiOAuthPasswordFlow;
class OpenApiOAuthClientCredentialsFlow extends OpenApiOAuthFlow {
    GetDefaultValue() {
        return Object.assign(Object.assign({}, super.GetDefaultValue()), { tokenUrl: "" });
    }
    constructor(...parts) {
        super(...parts);
        this.BASE_TYPE = OpenApiOAuthClientCredentialsFlow;
    }
    static isOpenApiOAuthImplicitFlow(o) {
        return (o instanceof OpenApiOAuthClientCredentialsFlow ||
            (OpenApiOAuthFlow.isOpenApiOAuthFlow(o) &&
                (0, utils_2.hasUnionKeysStrict)(o, [
                    "tokenUrl",
                ])));
    }
}
exports.OpenApiOAuthClientCredentialsFlow = OpenApiOAuthClientCredentialsFlow;
